/*
Author: Chathuraka Mallawa Arachchi
Date: 25/09/2025
Copyright © 2024 Infix!. All rights reserved.
*/

import { useRef, useState } from 'react'
import useKeyboardAccessibility from '../hooks/useKeyboardAccessibility'

const SingleChoice = (props: any) => {
    const {
        label,
        selectedValue,
        name,
        onChange,
        value,
        propDivClasses = '',
    } = props
    const [isFocused, setIsFocused] = useState(false)

    const handleKeyPress = () => {
        handleChange(value)
    }

    const ref = useRef<HTMLDivElement>(null)
    useKeyboardAccessibility(ref, handleKeyPress)

    const handleChange = (value: string) => {
        onChange(value)
    }

    return (
        <label key={value} className="checkbox-item">
            <div
                className={`${propDivClasses} input-div ${selectedValue ? 'input-div-selected' : ''} ${isFocused ? 'input-div-selected input-div-focused' : ''} `}
            >
                <input
                    type="checkbox"
                    value={value}
                    name={name}
                    checked={selectedValue}
                    onChange={() => handleChange(value)}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                />
                {label}
                <span className="checkmark"></span>
            </div>
        </label>
    )
}

export default SingleChoice
